$(document).on('ready', function () {

    var submitCount = 0;

    $('form').submit(function(e){

        if (submitCount == 1)
        {
            e.preventDefault();
            return;
        }
        submitCount++;

        setTimeout(function(){
            submitCount = 0;
        }, 500);
    });

});
